// init theme and style and icon
import 'element-ui/lib/theme-chalk/display.css';
import './assets/styles/normalize.scss';
import './assets/styles/common.scss';
// import './components/svgIcon'

import Vue from 'vue';
import VueQrcode from '@chenfengyuan/vue-qrcode';
import router from './router';
import extenal from './extenal';
import App from './App.vue';
import Imger from './components/imger/index.vue';

Vue.component('comp-imger', Imger);
Vue.component(VueQrcode.name, VueQrcode);

extenal(Vue);

Vue.config.productionTip = false;

// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router,
  render: h => h(App)
});

/**
 * 增加kind的步骤：
 * 1. 在 router/menu 中的 blacklist 中新增该kind不需要的菜单
 * 2. 然后检查剩下的所有菜单页的页面，为暂不支持的页面新增kind支持文件，如果页面一样，可使用其它kind的文件
 */
